let AdobeAn;
let exportRoot;
import createjs from 'createjs';
/* eslint-disable camelcase */
(function(cjs, an) {
    let p; // shortcut to reference prototypes
    const lib = {};
    const ss = {};
    const img = {};
    lib.ssMetadata = [];

    // symbols:
    // helper functions:

    function mc_symbol_clone() {
        const clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop));
        clone.gotoAndStop(this.currentFrame);
        clone.paused = this.paused;
        clone.framerate = this.framerate;
        return clone;
    }

    function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
        const prototype = cjs.extend(symbol, cjs.MovieClip);
        prototype.clone = mc_symbol_clone;
        prototype.nominalBounds = nominalBounds;
        prototype.frameBounds = frameBounds;
        return prototype;
    }

    (lib.Symbol1 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#808FA9')
            .s()
            .p('Ah5DTQgzgdAAhTQAAhSAyhXQAzhXBHgpQBHgqAzAeQAyAdABBTQAABSgzBXQgyBXhIApQgoAYgjAAQgZAAgVgMg');
        this.shape.setTransform(3, 1.7);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#9AA5C0')
            .s()
            .p('AiND2QhCgmgFhjQgFhjA7hlQA7hmBYgtQBXgtBCAmQBBAmAGBjQAFBjg7BlQg7BlhYAuQgvAYgpAAQgjAAgegRg');
        this.shape_1.setTransform(3, 1.7);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#B9C4E3')
            .s()
            .p('AgjAsIgrhfICdgbIg3Cdg');
        this.shape_2.setTransform(-13.6, 18.4);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#FFFFFF')
            .s()
            .p('AhZhvIBygbIBBAlIh/Dwg');
        this.shape_3.setTransform(8.3, -12.6);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#B9C4E3')
            .s()
            .p('AhqCEQg4ghgMhPQgMhOAkhaIBfA3QBmA7AnAVQAWALAZgEQAXgEAWANQg8BahRAlQgqATglAAQgiAAgegRg');
        this.shape_4.setTransform(-6.5, 9.6);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .f('#E7E7E7')
            .s()
            .p('ABOBzQgugIgVgKQgngWhTgvIhJgpQANgeAOgbQAWglAageQAyAcBLA4QBhBGAeAUIAqAYQgLAbgOAZIgQAZQgXgOgrgJg');
        this.shape_5.setTransform(-3.1, -3.8);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .f('#FFFFFF')
            .s()
            .p('ABbB/QgegThghHQhMg4gygcQA7hEBGgYQBFgZA2AeQA5AhALBSQAMBPgmBbIgqgYg');
        this.shape_6.setTransform(2.1, -12.9);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [{t: this.shape_6}, {t: this.shape_5}, {t: this.shape_4}, {t: this.shape_3}, {t: this.shape_2}, {t: this.shape_1}, {t: this.shape}]
                })
                .wait(1)
        );
    }).prototype = getMCSymbolPrototype(lib.Symbol1, new cjs.Rectangle(-24.3, -28, 48.7, 56.1), null);

    // stage content:
    (lib._8 = function(mode, startPosition, loop) {
        this.initialize(mode, startPosition, loop, {});

        // Layer_3 (mask)
        const mask = new cjs.Shape();
        mask._off = true;
        mask.graphics.p('AjjIdIhNyWIJhAAIg5Q6Ik8C5g');
        mask.setTransform(83.4, 63.4);

        // Symbol 1
        this.instance = new lib.Symbol1();
        this.instance.parent = this;
        this.instance.setTransform(82.5, 28.1);
        this.instance.alpha = 0;

        const maskedShapeInstanceList = [this.instance];

        for (let shapedInstanceItr = 0; shapedInstanceItr < maskedShapeInstanceList.length; shapedInstanceItr++) {
            maskedShapeInstanceList[shapedInstanceItr].mask = mask;
        }

        this.timeline.addTween(
            cjs.Tween.get(this.instance)
                .to({alpha: 1}, 4)
                .wait(5)
                .to({y: 166.3}, 12, cjs.Ease.get(-1))
                .wait(10)
        );

        // Слой 1
        this.shape = new cjs.Shape();
        this.shape.graphics
            .f('#9AA5C0')
            .s()
            .p('AjuAuIE+i3ICfBcIk+C3g');
        this.shape.setTransform(84.4, 112.9);

        this.shape_1 = new cjs.Shape();
        this.shape_1.graphics
            .f('#FFFFFF')
            .s()
            .p('AhwgoIDVgxIAMCzg');
        this.shape_1.setTransform(74.3, 153.3);

        this.shape_2 = new cjs.Shape();
        this.shape_2.graphics
            .f('#9AA5C0')
            .s()
            .p('AhXhZICvBWIiiBdg');
        this.shape_2.setTransform(93.2, 153.3);

        this.shape_3 = new cjs.Shape();
        this.shape_3.graphics
            .f('#FFFFFF')
            .s()
            .p('AhwgCIBEh9ICdD/g');
        this.shape_3.setTransform(11.3, 113.2);

        this.shape_4 = new cjs.Shape();
        this.shape_4.graphics
            .f('#9AA5C0')
            .s()
            .p('AhOh7ICRgEIAMD/g');
        this.shape_4.setTransform(14.8, 113.2);

        this.shape_5 = new cjs.Shape();
        this.shape_5.graphics
            .f('#9AA5C0')
            .s()
            .p('AAAAkQgMgIgJgPQgKgPAAgPQAAgPAKgFQAJgGAMAIQANAHAJAQQAJAPAAAPQAAAPgJAFQgDACgFAAQgGAAgIgEg');
        this.shape_5.setTransform(22.7, 195);

        this.shape_6 = new cjs.Shape();
        this.shape_6.graphics
            .f('#9AA5C0')
            .s()
            .p('AAAAkQgMgHgKgQQgJgPAAgPQAAgPAJgFQAKgGAMAIQANAIAJAQQAKAOgBAPQABAPgKAGQgDACgFAAQgGAAgIgFg');
        this.shape_6.setTransform(36.4, 204.4);

        this.shape_7 = new cjs.Shape();
        this.shape_7.graphics
            .f('#E7E7E7')
            .s()
            .p('AAADTQhLgsg2hcQg2hcAAhYQAAhXA2gfQA2gfBLAsQBMAsA2BdQA2BcAABXQAABYg2AeQgWANgaAAQglAAgtgag');
        this.shape_7.setTransform(31.7, 197.9);

        this.shape_8 = new cjs.Shape();
        this.shape_8.graphics
            .f('#9AA5C0')
            .s()
            .p('AgjgLIAigdIAmAsIhDAlg');
        this.shape_8.setTransform(47.7, 216.2);

        this.shape_9 = new cjs.Shape();
        this.shape_9.graphics
            .f('#9AA5C0')
            .s()
            .p('AgrABIA6ggIAdAWIAAApg');
        this.shape_9.setTransform(23.4, 175.2);

        this.shape_10 = new cjs.Shape();
        this.shape_10.graphics
            .f('#9AA5C0')
            .s()
            .p('AAADTQhLgsg2hdQg2hcAAhXQAAhYA2geQA2gfBLAsQBMAsA2BdQA2BcAABXQAABYg2AeQgWANgaAAQglAAgtgag');
        this.shape_10.setTransform(38.2, 194.3);

        this.shape_11 = new cjs.Shape();
        this.shape_11.graphics
            .f('#E7E7E7')
            .s()
            .p('AtXAAINXntINYHtItYHug');
        this.shape_11.setTransform(85.6, 112.9);

        this.shape_12 = new cjs.Shape();
        this.shape_12.graphics
            .f('#9AA5C0')
            .s()
            .p('Amrj2INXnuIAAPbItXHug');
        this.shape_12.setTransform(128.4, 187);

        this.shape_13 = new cjs.Shape();
        this.shape_13.graphics
            .f('#B9C4E3')
            .s()
            .p('AmrD3IAAvbINXHuIAAPbg');
        this.shape_13.setTransform(42.8, 187);

        this.shape_14 = new cjs.Shape();
        this.shape_14.graphics
            .f('#9AA5C0')
            .s()
            .p('AiwAyIAAjKIFeAAIADDLIivBmg');
        this.shape_14.setTransform(153.5, 219.7);

        this.shape_15 = new cjs.Shape();
        this.shape_15.graphics
            .f('#9AA5C0')
            .s()
            .p('AiwAxIAAjJIFdAAIAEDLIiwBmg');
        this.shape_15.setTransform(85.6, 258.7);

        this.shape_16 = new cjs.Shape();
        this.shape_16.graphics
            .f('#9AA5C0')
            .s()
            .p('AiwAyIAAjKIFeAAIADDMIivBlg');
        this.shape_16.setTransform(17.7, 220.3);

        this.timeline.addTween(
            cjs.Tween.get({})
                .to({
                    state: [
                        {t: this.shape_16},
                        {t: this.shape_15},
                        {t: this.shape_14},
                        {t: this.shape_13},
                        {t: this.shape_12},
                        {t: this.shape_11},
                        {t: this.shape_10},
                        {t: this.shape_9},
                        {t: this.shape_8},
                        {t: this.shape_7},
                        {t: this.shape_6},
                        {t: this.shape_5},
                        {t: this.shape_4},
                        {t: this.shape_3},
                        {t: this.shape_2},
                        {t: this.shape_1},
                        {t: this.shape}
                    ]
                })
                .wait(31)
        );
    }).prototype = p = new cjs.MovieClip();
    p.nominalBounds = new cjs.Rectangle(86, 137.5, 171.2, 274);
    // library properties:
    lib.properties = {
        id: '7BCF478645E14104BF9A1897A6A92292',
        width: 172,
        height: 275,
        fps: 24,
        color: '#CCCCCC',
        opacity: 0.0,
        manifest: [],
        preloads: []
    };

    // bootstrap callback support:

    (lib.Stage = function(canvas) {
        createjs.Stage.call(this, canvas);
    }).prototype = p = new createjs.Stage();

    p.setAutoPlay = function(autoPlay) {
        this.tickEnabled = autoPlay;
    };
    p.play = function() {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndPlay(this.getTimelinePosition());
    };
    p.stop = function(ms) {
        if (ms) this.seek(ms);
        this.tickEnabled = false;
    };
    p.seek = function(ms) {
        this.tickEnabled = true;
        this.getChildAt(0).gotoAndStop((lib.properties.fps * ms) / 1000);
    };
    p.getDuration = function() {
        return (this.getChildAt(0).totalFrames / lib.properties.fps) * 1000;
    };

    p.getTimelinePosition = function() {
        return (this.getChildAt(0).currentFrame / lib.properties.fps) * 1000;
    };

    an.bootcompsLoaded = an.bootcompsLoaded || [];
    if (!an.bootstrapListeners) {
        an.bootstrapListeners = [];
    }

    an.bootstrapCallback = function(fnCallback) {
        an.bootstrapListeners.push(fnCallback);
        if (an.bootcompsLoaded.length > 0) {
            for (let i = 0; i < an.bootcompsLoaded.length; ++i) {
                fnCallback(an.bootcompsLoaded[i]);
            }
        }
    };

    an.compositions = an.compositions || {};
    an.compositions['7BCF478645E14104BF9A1897A6A92292'] = {
        getStage: function() {
            return exportRoot.getStage();
        },
        getLibrary: function() {
            return lib;
        },
        getSpriteSheet: function() {
            return ss;
        },
        getImages: function() {
            return img;
        }
    };

    an.compositionLoaded = function(id) {
        an.bootcompsLoaded.push(id);
        for (let j = 0; j < an.bootstrapListeners.length; j++) {
            an.bootstrapListeners[j](id);
        }
    };

    an.getComposition = function(id) {
        return an.compositions[id];
    };
})((createjs = createjs || {}), (AdobeAn = AdobeAn || {}));

const composition = AdobeAn.getComposition('7BCF478645E14104BF9A1897A6A92292');

export {AdobeAn};
export {composition};
